import React, { useContext, useState } from "react"
import PropTypes from "prop-types"
import { ThemeContext } from "../contexts/theme-context"
import { ViewportContext } from "../contexts/viewport-context"

const AboutNav = ({ buttonClick, lang = "de" }) => {
  const [state, setState] = useState(0)
  const navNames = require("../data/about.json").navigation
  const theme = useContext(ThemeContext)[0]
  const dimensions = useContext(ViewportContext)

  return (
    <>
      <input
        type="radio"
        name={`about-nav-${lang}`}
        id={`about-slide-${lang}-1`}
        onChange={() => setState(0)}
        checked={!state}
      />
      <input
        type="radio"
        name={`about-nav-${lang}`}
        id={`about-slide-${lang}-2`}
        onChange={() => setState(1)}
        checked={state === 1}
      />
      <input
        type="radio"
        name={`about-nav-${lang}`}
        id={`about-slide-${lang}-3`}
        onChange={() => setState(2)}
        checked={state === 2}
      />
      <input
        type="radio"
        name={`about-nav-${lang}`}
        id={`about-slide-${lang}-4`}
        onChange={() => setState(3)}
        checked={state === 3}
      />
      <input
        type="radio"
        name={`about-nav-${lang}`}
        id={`about-slide-${lang}-5`}
        onChange={() => setState(4)}
        checked={state === 4}
      />
      <style>{`.page-navigation.about-nav {
          margin-top: ${dimensions[0] < 641 ? "400px" : "4.5vw"};
          margin-left: ${dimensions[0] < 641 ? "4.5vw" : "50%"};
        }`}</style>
      <aside
        className={
          theme[0] === "dark" && theme[1] === "full"
            ? "page-navigation about-nav text-white"
            : "page-navigation about-nav"
        }
      >
        <button onClick={() => buttonClick(0)}>
          <label htmlFor={`about-slide-${lang}-1`}>{navNames[lang][0]}</label>
        </button>
        <button onClick={() => buttonClick(1)}>
          <label htmlFor={`about-slide-${lang}-2`}>{navNames[lang][1]}</label>
        </button>
        <button onClick={() => buttonClick(2)}>
          <label htmlFor={`about-slide-${lang}-3`}>{navNames[lang][2]}</label>
        </button>
        <button onClick={() => buttonClick(3)}>
          <label htmlFor={`about-slide-${lang}-4`}>{navNames[lang][3]}</label>
        </button>
        <button onClick={() => buttonClick(4)}>
          <label htmlFor={`about-slide-${lang}-5`}>{navNames[lang][4]}</label>
        </button>
      </aside>
    </>
  )
}

AboutNav.propTypes = {
  buttonClick: PropTypes.func,
  lang: PropTypes.string,
}

export default AboutNav
